import { ShieldCheck, Gem } from "lucide-react";
import { IMAGES } from "@/data/site";
import { Reveal } from "./Reveal";

const PILLARS = [
  {
    num: "01",
    icon: ShieldCheck,
    title: "Higiene Rigorosa",
    text: "Todos os materiais são esterilizados após cada utilização. Ambiente impecavelmente limpo e higienizado, para a sua total segurança.",
    testid: "manifesto-item-1",
  },
  {
    num: "02",
    icon: Gem,
    title: "Materiais 100% Novos",
    text: "Utilizamos materiais novos e esterilizados em cada atendimento, garantindo máxima segurança e confiança em todos os serviços.",
    testid: "manifesto-item-2",
  },
];

export const Manifesto = () => (
  <section id="sobre" data-testid="about-section" className="py-16 sm:py-24 lg:py-32 bg-white overflow-hidden">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
      <div className="lg:col-span-5 relative order-2 lg:order-1">
        <Reveal>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden shadow-2xl shadow-[#C2185B]/15 aspect-[3/4] max-w-sm">
              <img
                src={IMAGES.treatmentRoom}
                alt="Sala de tratamentos do Espaço da Beleza"
                loading="lazy"
                className="w-full h-full object-cover hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="absolute -bottom-8 -right-2 sm:right-0 lg:-right-10 w-44 sm:w-56 rounded-2xl overflow-hidden border-[5px] border-white shadow-xl aspect-square">
              <img
                src={IMAGES.vanity}
                alt="Detalhe da decoração do salão"
                loading="lazy"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </Reveal>
      </div>

      <div data-testid="manifesto-section" className="lg:col-span-7 order-1 lg:order-2">
        <Reveal>
          <p className="text-xs sm:text-sm font-medium tracking-[0.25em] uppercase text-[#C2185B]">
            Sobre o Espaço
          </p>
          <h2 className="mt-4 font-serif-display text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-stone-900 max-w-lg">
            Um refúgio <em className="text-[#C2185B]">rosa</em> dedicado ao seu
            bem-estar
          </h2>
        </Reveal>

        <div className="mt-10 space-y-0">
          {PILLARS.map((p, i) => (
            <Reveal key={p.num} delay={i * 0.1}>
              <div
                data-testid={p.testid}
                className="group flex gap-5 sm:gap-8 py-7 border-t border-rose-100 last:border-b hover:bg-[#FFF0F5]/60 transition-colors duration-300 rounded-lg px-2 sm:px-4"
              >
                <span className="font-serif-display italic text-3xl sm:text-4xl text-[#F8BBD0] group-hover:text-[#C2185B] transition-colors duration-300 leading-none pt-1">
                  {p.num}
                </span>
                <div>
                  <h3 className="flex items-center gap-2.5 font-serif-display text-xl sm:text-2xl font-semibold text-stone-900">
                    <p.icon size={19} className="text-[#C2185B]" />
                    {p.title}
                  </h3>
                  <p className="mt-2 text-sm sm:text-base text-stone-600 leading-relaxed max-w-lg">
                    {p.text}
                  </p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-8 flex flex-wrap gap-3">
            {[
              { label: "Materiais Esterilizados", testid: "about-badge-hygiene" },
              { label: "Materiais 100% Novos", testid: "about-badge-new-materials" },
            ].map((b) => (
              <span
                key={b.label}
                data-testid={b.testid}
                className="inline-flex items-center gap-2 text-xs sm:text-sm font-semibold text-[#C2185B] border border-[#C2185B]/25 bg-[#FCE4EC]/60 px-4 py-2 rounded-full"
              >
                ♡ {b.label}
              </span>
            ))}
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
